<header class="header--page">
    <ul class="header__nav">
        <li>
            <h1>An Error Has Occurred</h1>
        </li>
    </ul>
</header>

<div class="mvd_container">
    <div class="well">
        <h2 class="mvd_alert--label icon--alert">Unable to Find Requested Resource</h2>
        <br />
        <div class="well__footer">
            <button class="btn--default" type="button" onClick="javascript:history.back(1)">Back</button>
            <button class="btn--primary" type="submit" [routerLink]="['/']">Home</button>
        </div>
    </div>
</div>